export const normalizeLicenseId = (id: string): string => {
  return id.toUpperCase();
}
